/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-option-disabled), .mat-option[_ngcontent-%COMP%]:hover:not(.mat-option-disabled){color:inherit;font-weight:inherit;background:inherit;font-family:inherit}[_nghost-%COMP%]     mat-pseudo-checkbox{display:none}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/select-all/select-all.component.scss.shim.ngstyle.js.pre-build-optimizer.js